import { render, staticRenderFns } from "./SpacePlandayUsers.vue?vue&type=template&id=162cdfb4"
import script from "./SpacePlandayUsers.vue?vue&type=script&lang=js"
export * from "./SpacePlandayUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports